<template>
  <div class="myhome-myschool xs-12 m-8 l-9">
    <div class="myhome-myschool__title dea-heading--medium-xxl" tabindex="0">
      Io e la scuola
    </div>
    <div class="myhome-myschool__content">
      <div class="myhome-myschool__school-grade">
        <div class="myhome-myschool__school-grade-header">
          <div class="myhome-myschool__school-grade-header-title dea-heading--medium-m">Grado scolastico</div>
          <Links
            class="myhome-myschool__school-grade-header-link dea-links--large"
            :class="`dea-links--${user.targetCss.colorMod}`"
            @click="modalVisible = true"
          >
            Modifica
          </Links>
        </div>
        <div class="myhome-myschool__school-grade-content dea-heading--regular-s">
          {{ studentGradeLabel }}
        </div>
      </div>
      <div v-if="!studentSchoolGrades[user.student_school]" class="myhome-myschool__school-type">
        <div class="myhome-myschool__school-type-header">
          <div class="myhome-myschool__school-type-header-title dea-heading--medium-m">Tipologia di istituto</div>
        </div>
        <div class="myhome-myschool__school-grade-content dea-heading--regular-s">
          {{ user.student_school.charAt(0).toUpperCase() + user.student_school.slice(1) }}
        </div>
      </div>
      <Modal
        v-if="modalVisible"
        class="dea-modal--no-footer"
        :visible="modalVisible"
        @modal-close="modalVisible = false"
      >
        <template slot="title">
          <div>
            Modifica il tuo grado scolastico e la tipologia di scuola
          </div>
        </template>
        <template slot="content">
          <div class="myhome-myschool__modal-grades-list">
            <div class="myhome-myschool__modal-grades-list-title dea-heading--medium-m">Seleziona grado scolastico</div>
            <div class="myhome-myschool__modal-grades-list-buttons">
              <Buttons
                v-for="(grade, idx) in $root.config.grades"
                :key="idx"
                class="dea-button--large dea-button--outline"
                :class="[
                  { 'dea-button--not-selected': idx + 1 !== gradeIdSelected },
                  { 'dea-button--selected': idx + 1 === gradeIdSelected },
                ]"
                @click="setGrade(idx + 1)"
              >
                {{ grade }}
              </Buttons>
            </div>
          </div>
          <div v-if="gradeIdSelected === 3" class="myhome-myschool__modal-school-type">
            <div class="myhome-myschool__modal-school-type-title dea-heading--medium-m">Seleziona grado scolastico</div>
            <div class="myhome-myschool__modal-school-type-buttons">
              <Buttons
                v-for="(type, idx) in $root.config.schoolsTypologies"
                :key="idx"
                class="dea-button--large dea-button--outline"
                :class="[
                  { 'dea-button--not-selected': type.toLowerCase() !== typeSchoolSelected.toLowerCase() },
                  { 'dea-button--selected': type.toLowerCase() === typeSchoolSelected.toLowerCase() },
                ]"
                @click="setType(type)"
              >
                {{ type }}
              </Buttons>
            </div>
          </div>
          <Buttons
            class="myhome-myschool__modal-button-save dea-button--large"
            :disabled="!payload.student_school"
            @click="saveSettings"
          >
            Salva modifiche
          </Buttons>
        </template>
      </Modal>
    </div>
  </div>
</template>

<script>
import * as Sentry from "@sentry/vue";
import { mapActions, mapGetters } from "vuex";
import Buttons from "@/components/elements/Buttons";
import Links from "@/components/elements/Links";
import Modal from "@/components/patterns/Modal";
import User from "../../../clients/user";
import setFocus from "~/helpers/setFocus";

export default {
  name: "MyProfileMySchool",
  components: { Buttons, Links, Modal },
  props: {},
  data() {
    return {
      gradeIdSelected: 0,
      gradeLabelSelected: "",
      modalVisible: false,
      payload: {
        student_school: "",
      },
      studentSchoolGrades: {
        primaria: 1,
        secondaria: 2,
      },
      typeSchoolSelected: "",
    };
  },
  computed: {
    ...mapGetters(["user"]),
    studentGradeLabel() {
      if (!this.user.student_school) {
        return "Scegli il tuo grado scolastico";
      }
      if (this.studentSchoolGrades[this.user.student_school]) {
        return this.$root.asyncConf.degrees_json
          .filter(grade => grade.id === this.studentSchoolGrades[this.user.student_school])
          .map(el => el.name)
          .join("");
      }
      return this.$root.asyncConf.degrees_json[2].name;
    },
  },
  mounted() {
    setFocus("myhome-myschool__title");

    this.getGradeAndType();
  },
  activated() {
    setFocus("myhome-myschool__title");
  },
  methods: {
    ...mapActions(["fetchUser"]),
    getGradeAndType() {
      if (!this.user.student_school) {
        this.gradeIdSelected = 0;
        this.gradeLabelSelected = "";
        this.typeSchoolSelected = "";
      } else if (this.studentSchoolGrades[this.user.student_school]) {
        const actualGrade = this.$root.asyncConf.degrees_json
          .filter(grade => grade.id === this.studentSchoolGrades[this.user.student_school])
          .map(el => el.id);
        [this.gradeIdSelected] = actualGrade;
        this.gradeLabelSelected = this.$root.asyncConf.degrees_json
          .filter(grade => grade.id === this.studentSchoolGrades[this.user.student_school])
          .map(el => el.name)
          .join("");
      } else {
        this.gradeIdSelected = 3;
        this.gradeLabelSelected = this.$root.asyncConf.degrees_json[2].name;
        this.typeSchoolSelected = this.user.student_school;
      }
    },
    setGrade(gradeId) {
      this.gradeIdSelected = gradeId;

      if (this.gradeIdSelected === 3) {
        this.gradeLabelSelected = this.$root.asyncConf.degrees_json[2].name;
      } else {
        this.gradeLabelSelected = this.$root.asyncConf.degrees_json
          .filter(grade => grade.id === this.gradeIdSelected)
          .map(el => el.name)
          .join("");
      }
      this.payload.student_school = Object.keys(this.studentSchoolGrades).find(
        key => this.studentSchoolGrades[key] === gradeId
      );
    },
    setType(type) {
      this.typeSchoolSelected = type;
      this.payload.student_school = type.toLowerCase();
    },
    async saveSettings() {
      document.querySelector("body").classList.add("wait");
      try {
        await User.modifyUserEntities(this.$root.config, this.user.id, this.payload);
        await this.fetchUser(true);
      } catch (e) {
        Sentry.captureException(e);
      }
      document.querySelector("body").classList.remove("wait");
      this.modalVisible = false;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.myhome-myschool {
  &__title {
    margin-bottom: $space-large;
  }

  &__school-grade,
  &__school-type {
    margin-bottom: $space-intermediate;

    &-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding-bottom: $space-base;

      &-link {
        cursor: pointer;
      }
    }
  }

  &__modal-grades-list {
    margin-bottom: $space-large;

    &-buttons {
      @include media("<m") {
        flex-direction: column;
      }

      display: flex;
      flex-direction: row;

      button {
        margin-right: $space-base;
        margin-top: $space-base;
      }
    }
  }

  &__modal-school-type {
    margin-bottom: $space-large;

    &-buttons {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;

      button {
        margin-right: $space-base;
        margin-top: $space-base;
      }
    }
  }

  .dea-button {
    &--not-selected,
    &--not-selected .dea-button__label {
      border-color: $dea-color-grey-medium;
      color: $dea-color-grey-medium;
    }

    &--selected {
      border-color: $dea-color-black;
    }
  }

  .dea-modal {
    @include media("<s") {
      width: 100%;
    }

    max-height: 90vh;
    overflow-y: auto;
  }
}
</style>
